import React, { Component } from 'react';
import './CustomMap.css';
import pixel from './imgs/pixel.jpg';
import locationIcon from './imgs/locationIcon.png';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { HOST } from '../../constants/Fetch'
import Preloader from '../../components/Preloader';
import ErrorMessage from '../../components/ErrorMessage';
import requestAll from '../../actions/Common';
import { bindActionCreators } from 'redux';
import { loadMap } from '../../actions/MapActions';
import $ from "jquery";
import ymaps from 'ymaps';
import getNoun from '../../utils/getNoun.js';
import PropTypes from 'prop-types';

const checkAvailability = (arr, val) => {
  return arr.some(arrVal => val === arrVal);
}

let geoMap;

const mapInit = (self) => {
  ymaps.load('https://api-maps.yandex.ru/2.1/?lang=ru_RU').then(() => {
    let width = self.context.width;
    let zoomval = 0;
    let area = [[82, 11],[37, 195]];
    if (width <= 400) {
      area = [[82, 10],[10, 195]];
      zoomval = 1;
    } else if (width <= 800) {
      area = [[82, 10],[17, 195]]
      zoomval = 2;
    } else if (width <= 1220) {
      area = [[40, 10], [85,-160]];
    } else if (width <= 1600) {
      area = true
      zoomval = 3;
    } else {
      zoomval = 4;
    }

    const ymaps = global.ymaps;
    ymaps.ready(function () {
      geoMap = new ymaps.Map('mapContainer', {
        center: [61.8, 97],
        zoom: zoomval,
        type: null,
        controls: []
      },{
        restrictMapArea: area,
        maxZoom: 9
      });

      const isoCodes = [];
      if (self.props.cities) {
        for (let i = 0; i < self.props.cities.length; i++) {
          isoCodes[i] =  self.props.cities[i].iso_code
        }
      }

      geoMap.layers.add(new ymaps.Layer(pixel));
      ymaps.borders.load('RU', {
        lang: 'ru',
        quality: 1
      }).then(function (result) {
        var regions = ymaps.geoQuery(result);
        regions.setOptions({
            fillColor: 'b2b4b1',
            strokeWidth: 1,
            strokeColor: 'fff',
            zIndex: 1,
            zIndexHover: 1
        });
        regions.each(function(reg) {
          if (checkAvailability(isoCodes, reg.properties.get('iso3166'))) {
            reg.options.set({
              fillColor: '80b0d3',
              strokeWidth: 1,
              strokeColor: 'fff',
            })
          }
        });
        regions.addToMap(geoMap);
      });

      const cityItems = [];
      if (self.props.cities) {
        for (let i = 0; i < self.props.cities.length; i++) {
          cityItems[i] = {
            coords: [self.props.cities[i].lat,self.props.cities[i].lng],
            name: self.props.cities[i].name,
            id: self.props.cities[i].id,
            image: self.props.cities[i].image,
            companies: self.props.cities[i].companies,
            vacancy_count: 0
          }
          for (let n = 0; n < cityItems[i].companies.length; n++) {
            cityItems[i].vacancy_count += cityItems[i].companies[n].vacancy_count;
          }
        }
      }

      // поповер
      const BalloonLayout = ymaps.templateLayoutFactory.createClass(
        '<div class="customMap__popover">' +
          '<a class="customMap__popoverClose" href="#"></a>' +
          '<div class="customMap__popoverArrow"></div>' +
          '<div class="customMap__popoverInner">' +
            '$[[options.contentLayout observeSize minWidth=260 maxWidth=260 maxHeight=550]]' +
          '</div>' +
        '</div>', {
        build: function () {
          this.constructor.superclass.build.call(this);
          this._$element = $('.customMap__popover', this.getParentElement());
          this.applyElementOffset();
          this._$element.find('.customMap__popoverClose')
            .on('click', $.proxy(this.onCloseClick, this));
        },
        clear: function () {
          this._$element.find('.customMap__popoverClose')
            .off('click');
          this.constructor.superclass.clear.call(this);
        },
        onSublayoutSizeChange: function () {
          BalloonLayout.superclass.onSublayoutSizeChange.apply(this, arguments);
            if(!this._isElement(this._$element)) {
              return;
            }
            this.applyElementOffset();
            this.events.fire('shapechange');
        },
        applyElementOffset: function () {
          this._$element.css({
            left: -(this._$element[0].offsetWidth / 2),
            top: -(this._$element[0].offsetHeight + this._$element.find('.customMap__popoverArrow')[0].offsetHeight) - 10
          });
        },
        onCloseClick: function (e) {
          e.preventDefault();
          this.events.fire('userclose');
        },
        getShape: function () {
            if(!this._isElement(this._$element)) {
                return BalloonLayout.superclass.getShape.call(this);
            }
            var position = this._$element.position();
            return new ymaps.shape.Rectangle(new ymaps.geometry.pixel.Rectangle([
                [position.left, position.top], [
                    position.left + this._$element[0].offsetWidth,
                    position.top + this._$element[0].offsetHeight + this._$element.find('.customMap__popoverArrow')[0].offsetHeight
                ]
            ]));
        },
        _isElement: function (element) {
          return element && element[0] && element.find('.customMap__popoverArrow')[0];
        }
      });
      // контент поповера
      const BalloonContentLayout = ymaps.templateLayoutFactory.createClass(
        '{% if properties.ballonImg !== null %}' +
          '<img class="customMap__popoverImage" src=$[properties.host]{{properties.ballonImg}} />' +
        '{% endif %}' +
        '<div class="customMap__popoverContent">' +
          '<div class="customMap__popoverTitle">{{ properties.balloonTitle }}</div>' +
          '<a href="/vacancies?city={{ properties.balloonID }}" class="customMap__popoverCount">{{ properties.balloonCount }}</a>' +
          '{% for company in properties.companies %}' +
            '<div class="customMap__company">' +
              '{% if company.logo !== null %}' +
                '<img class="customMap__companyLogo" src="$[properties.host]{{company.logo}}" alt={{company.name}} />' +
              '{% endif %}' +
              '<div class="customMap__companyName">{{company.name}}</div>' +
              '<a href="/vacancies?company={{ company.id }}&city={{ properties.balloonID }}" class="customMap__companyCount">{{company.vacancy_count}}' +
                '{% if company.vacancy_count == 1 %} вакансия' +
                '{% elseif (company.vacancy_count == 2 || company.vacancy_count == 3 || company.vacancy_count == 4) %} вакансии' +
                '{% else %} вакансий' +
                '{% endif %}' +
              '</a>' +
              '<div class="customMap__companyContent">{{company.contact_info|raw}}</div>' +
            '</div>' +
          '{% endfor %}'+
        '</div>'
      );

      // контент иконки счетчика
      const IconContentLayout = ymaps.templateLayoutFactory.createClass(
        '<div class="customMap__iconContent">$[properties.iconContent]</div>' +
        '<div class="customMap__iconCity">' +
          '{{ properties.iconCaption }}' +
        '</div>'
      );

      const collectionWithContent = [];

      for (var i = 0, l = cityItems.length; i < l; i++) {
        collectionWithContent[i] = new ymaps.Placemark(cityItems[i].coords, {
          iconContent: cityItems[i].vacancy_count,
          iconCaption: cityItems[i].name,
          ballonImg: cityItems[i].image,
          balloonTitle: cityItems[i].name,
          balloonID: cityItems[i].id,
          balloonCount: cityItems[i].vacancy_count + getNoun(cityItems[i].vacancy_count, ' вакансия', ' вакансии', ' вакансий'),
          companies: cityItems[i].companies,
          host: HOST,
          placemarkId: i
        }, {
          hideIconOnBalloonOpen: false,
          iconLayout: 'default#imageWithContent',
          iconImageHref: locationIcon,
          iconImageSize: [34, 41],
          iconImageOffset: [-17, -48],
          iconContentOffset: [4, 11],
          iconContentLayout: IconContentLayout,
          balloonPanelMaxMapArea: 0,
          balloonLayout: BalloonLayout,
          balloonContentLayout: BalloonContentLayout,
        });

        collectionWithContent[i].events.add('balloonopen', function (e) {
          e.originalEvent.currentTarget.options.set({
            iconImageHref: ''
          });
        });

        collectionWithContent[i].events.add('balloonclose', function (e) {
          e.originalEvent.currentTarget.options.set({
            iconImageHref: locationIcon
          });
        });
      };

      // слой для отображения кластера
      const ClusterIconLayout = ymaps.templateLayoutFactory.createClass(
        '<span class="customMap__cluster">{{ properties.count }}</span>'
      );

      const clusterer = new ymaps.Clusterer({
        preset: 'islands#invertedOrangeClusterIcons',
        groupByCoordinates: false,
        hasBalloon: false,
        gridSize: 128,
        hasHint: false,
        maxZoom: 9,
        clusterIconContentLayout: ClusterIconLayout
      });
      clusterer.createCluster = function(center, geoObjects) {
        let count = 0;
        for (var i = 0, l = geoObjects.length; i < l; i ++) {
          count += geoObjects[i].properties._data.iconContent;
        }
        const createCluster = ymaps.Clusterer.prototype.createCluster;
        const cluster = createCluster.call(this, center, geoObjects);
        cluster.properties.set('count', count);
        return cluster;
      };

      geoMap.events.add('actiontick', function () {
        self.setState({ mapEnabled: true })
      })

      geoMap.events.add('wheel', function (e) {
        const domEvent = e.get('domEvent')
        if (domEvent.get('ctrlKey') || domEvent.get('metaKey')) {
          geoMap.behaviors.enable('scrollZoom');
          self.setState({ mapEnabled: true })
        } else {
          geoMap.behaviors.disable('scrollZoom');
          self.setState({
            mapEnabled: false,
            eventMessage: 'Чтобы изменить масштаб, нажмите Ctrl + прокрутка'
          })
        }
      });

      clusterer.add(collectionWithContent);

      geoMap.geoObjects.add(clusterer);
    });
  });
}

class CustomMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mapEnabled: true,
      eventMessage: "",
      swipe: false
     };
  }

  onTouchStart = (e) => {
    if(e.touches.length == 1) {
      geoMap.behaviors.disable('drag');

    }
    if(e.touches.length == 2) {
      geoMap.behaviors.enable('drag');
      this.setState({swipe: true });
    }
  }

  onTouchMove = () => {
    if(this.state.swipe) {
      this.setState({ mapEnabled: true});
    } else {
      this.setState({
        mapEnabled: false,
        eventMessage: "Чтобы переместить карту, проведите по ней двумя пальцами"
      });
    }
  }

  onTouchEnd = () => {
    this.setState({
      mapEnabled: true
    });
  }

  onMouseEnter = () => {
    geoMap.behaviors.disable('scrollZoom');
  }

  onMouseLeave = () => {
    geoMap.behaviors.enable('scrollZoom');
    this.setState({mapEnabled: true})
  }

  static requestData(store) {
    return requestAll([loadMap], store);
  }

  static contextTypes = {
    width: PropTypes.number
  };

  componentDidMount() {
    this.props.actions.loadMap().then(() => {
      mapInit(this)
    })
  }

  render() {
    if (this.props.hasErrored) {
      return <ErrorMessage/>;
    }
    if (this.props.isLoading) {
       return <Preloader/>;
    }
    return (
      <div className="customMap">
        <div className={`customMap__fade ${this.state.mapEnabled ? '' : 'customMap__fade--active'}`}>{this.state.eventMessage}</div>
        <div
          id="mapContainer"
          className={`customMap__container ${this.state.mapEnabled ? '' : 'customMap__container--disabled'}`}
          onTouchStart={this.onTouchStart}
          onTouchMove={this.onTouchMove}
          onTouchEnd={this.onTouchEnd}
          onMouseEnter={this.onMouseEnter}
          onMouseLeave={this.onMouseLeave}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    cities: state.map.list,
    hasErrored: state.map.hasErrored,
    isLoading: state.map.isLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({ loadMap }, dispatch),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CustomMap));





// WEBPACK FOOTER //
// ./src/components/CustomMap/index.js